import axios from 'axios';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { API_ENDPOINT, HEADER_TOKEN } from '../../constants/constants';
import './auditLog.css';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const MONTHS = [
    { value: "01", name: "January" }, { value: "02", name: "February" }, { value: "03", name: "March" },
    { value: "04", name: "April" }, { value: "05", name: "May" }, { value: "06", name: "June" },
    { value: "07", name: "July" }, { value: "08", name: "August" }, { value: "09", name: "September" },
    { value: "10", name: "October" }, { value: "11", name: "November" }, { value: "12", name: "December" },
];

const AuditLog = () => {
    const currentYear = new Date().getFullYear();
    const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');

    const [al, setAl] = useState([]);
    const [pb, setPb] = useState(false);
    const [year, setYear] = useState(currentYear.toString());
    const [month, setMonth] = useState(currentMonth);
    const [searchText, setSearchText] = useState('');

    const formatDate = (str) => {
        let d = new Date(str);
        if (isNaN(d)) return "Invalid Date";
        // Time as well: several actions a day were indistinguishable by date alone.
        const p2 = (n) => n.toString().padStart(2, "0");
        return `${p2(d.getDate())}/${p2(d.getMonth() + 1)}/${d.getFullYear()} ${p2(d.getHours())}:${p2(d.getMinutes())}`;
    };

    const exportToExcel = () => {
        const worksheetData = al.map((item, index) => ({
            "Sl No": index + 1, "Origin": item.origin, "Activity": item.message,
            "User": item.user, "Date": formatDate(item.date),
        }));
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "AuditLogs");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), `AuditLog_${year}-${month}.xlsx`);
    };

    useEffect(() => { loadAls(searchText, month, year); }, [month, year]);

    const loadAls = (searchQ = '', cmonth = month, cyear = year) => {
        setPb(true);
        axios.post(API_ENDPOINT + 'sam/get-audit-logs', { searchQ, cmonth, cyear }, HEADER_TOKEN).then(res => {
            setPb(false);
            let d = res.data;
            if (d.success) { setAl(d.message); } else { toast(d.message); }
        }).catch(() => setPb(false));
    };

    const onSearch = (e) => {
        const v = e.target.value;
        setSearchText(v);
        loadAls(v, month, year);
    };

    const years = [];
    for (let y = 2023; y <= currentYear; y++) years.push(y.toString());

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <div style={{ flex: 1 }}><h3 style={{ margin: 0 }}>Audit log</h3></div>
                <select className="input" style={{ width: 'auto', minHeight: 38 }} value={year} onChange={(e) => setYear(e.target.value)}>
                    {years.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
                <select className="input" style={{ width: 'auto', minHeight: 38 }} value={month} onChange={(e) => setMonth(e.target.value)}>
                    {MONTHS.map(m => <option key={m.value} value={m.value}>{m.name}</option>)}
                </select>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, height: 38, padding: '0 12px', background: 'var(--color-surface)', border: '1px solid var(--color-divider)', width: 200, color: 'var(--color-neutral-500)' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
                    <input value={searchText} onChange={onSearch} placeholder="Search…" style={{ border: 0, background: 'transparent', outline: 'none', font: 'inherit', fontSize: 13, color: 'var(--color-text)', width: '100%' }} />
                </div>
                <button className="btn btn-secondary" onClick={exportToExcel}>
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" x2="12" y1="15" y2="3" /></svg>
                    Export
                </button>
            </div>

            <div style={{ background: 'var(--color-surface)', padding: '6px 18px 12px' }}>
                <table className="table">
                    <thead>
                        <tr><th>#</th><th>Origin</th><th>Activity</th><th>User</th><th>Date</th></tr>
                    </thead>
                    <tbody>
                        {pb ? (
                            <tr><td colSpan={5} className="text-muted" style={{ textAlign: 'center', padding: 24 }}>Loading audit log…</td></tr>
                        ) : al.length > 0 ? al.map((a, i) => (
                            <tr key={i}>
                                <td className="text-muted">{i + 1}</td>
                                <td><span className="tag tag-neutral">{a.origin}</span></td>
                                <td>{a.message}</td>
                                <td className="text-muted">{a.user}</td>
                                <td className="text-muted" style={{ whiteSpace: 'nowrap' }}>{formatDate(a.date)}</td>
                            </tr>
                        )) : (
                            <tr><td colSpan={5} className="text-muted" style={{ textAlign: 'center', padding: 24 }}>No activity for this period</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AuditLog;
